import ccpa from "crypto-pro-cadesplugin";
import cadescomMethods from "crypto-pro-cadesplugin/dist/cadescomMethods";

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

function b64toBlob(b64Data, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(b64Data);

  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

export const signFile = async ({ file = null, thumbprint }) => {
  if (file) {
    const header = ";base64,";
    const sFileData = await toBase64(file);
    const sBase64Data = sFileData.substr(sFileData.indexOf(header) + header.length);
    const type = sFileData.substr(0, sFileData.indexOf(header));
    const certsApi = await ccpa();
    const sign = await certsApi.signBase64(thumbprint, sBase64Data);
    const contentType = type.split(":")[1];
    const blob = b64toBlob(sign, contentType);
    return { blob, fileName: `${file.name}.1.sig` };
  }
  return { blob: null, fileName: null };
};

export const getInfoFromSignedData = async (sSignedMessage) => {
  let signersTxt;
  let messageErr = ""
  let CADESCOM_CADES_BES = 1;
  let CADESCOM_BASE64_TO_BINARY = 1;
  // Чтоб не гонять PDF лишний раз, суём рандомный Base64
  // В данном случае закодирована строка "Some Data."
  let dataInBase64 = "U29tZSBEYXRhLg==";
  let SigningTime = 'н/д';
  // try {
  //   let oSignedData2 = await cadescomMethods.oSignedData();
  //   try {
  //     await oSignedData2.VerifyCades(sSignedMessage, CADESCOM_CADES_BES);
  //   } catch (ex) {
  //     messageErr = ex.message;//certsApi.getLastError(ex);
  //   }
  //   let oSigners
  //   try {
  //     oSigners= await oSignedData2.Signers;
  //   } catch (ex){
  //     messageErr = ex.message;
  //   }
  //   let item = await oSigners.Item(1)
  //   SigningTime = await item.SigningTime;
  //   let z = SigningTime;
  //   alert(z)
  // } catch (ex){
  //   messageErr = ex.message;
  //   alert(messageErr)
  // }
  try {
    let oSignedData = await cadescomMethods.oSignedData();
    try {
      await oSignedData.propset_ContentEncoding(CADESCOM_BASE64_TO_BINARY);
      await oSignedData.propset_Content(dataInBase64);
      await oSignedData.VerifyCades(sSignedMessage, CADESCOM_CADES_BES, true);
    }
    catch (ex) {
        // Гасим ошибку если верификация не прошла,
        // а она не прошла, так как левые данные на проверке. :)
        // Нам важны только аттрибуты подписи.
      messageErr = "Ошибка при создании oSignedData: " + ex.message;//certsApi.getLastError(ex);
      //console.log(messageErr);
    }
    let signers, signersCnt, SubjectName, ValidFromDate, ValidToDate, SerialNumber, IssuerName, Version;
    try {
      signers =  await oSignedData.Signers;
      signersCnt =  await signers.Count;
    } catch (ex) {
      messageErr = "Ошибка в получении подписи или их количества: " + ex.message;//certsApi.getLastError(ex);
      //console.log(messageErr);
     }
      for (let i = 1; i <= signersCnt; i++) {
        let signer;
        try {
          signer =  await signers.Item(i);
          let cert =  await signer.Certificate;
          SubjectName =  await cert.SubjectName;
          ValidFromDate = new Date(await cert.ValidFromDate);
          ValidToDate = new Date(await cert.ValidToDate);
          SerialNumber = await cert.SerialNumber;
          IssuerName = await cert.IssuerName;
          Version = await cert.Version;
          // try {
          //   SigningTime = await signer.SigningTime;
          // }catch (ex){
          //   messageErr = ex.message;
          // }
          // Возвращаемый объект
          signersTxt = {
            "SubjectName": SubjectName,
            "ValidFromDate": ValidFromDate,
            "ValidToDate": ValidToDate,
            "SerialNumber": SerialNumber,
            "IssuerName": IssuerName,
            "Version": Version,
            "SigningTime":SigningTime
          };
        } catch (ex) {
          messageErr = "Ошибка при получении аттрибутов подписи: " + ex.message;
          console.log(messageErr);
          return;
        }
      }
    return signersTxt
  } catch (error) {
    throw new Error(error.message);
  }
}

const checkQuotes = str => {
  let result = 0;

  for (let i = 0; i < str.length; i++) if (str[i] === '"') result++;
  return !(result % 2);
};

export const extract = (from, what) => {
  let certName = "";

  const begin = from.indexOf(what) + what.length;

  if (begin >= 0) {
    let end = from.indexOf(", ", begin);
    while (end > 0) {
      if (checkQuotes(from.substr(begin, end - begin))) break;
      end = from.indexOf(", ", end + 1);
    }
    certName = end < 0 ? from.substr(begin) : from.substr(begin, end - begin);
  }

  return certName;
};


//dataInBase64 - file pdf new
//sSignedMessage - подпись base64 new
//SignatureBoxId - подпись олд
//SignInfoBoxId - окно вывода олд


/*function VerifySignature_NPAPI(dataInBase64, sSignedMessage) {
  const cadesplugin = window.cadesplugin// require('../cadesplugin_api.js')
  try {
    if (sSignedMessage === "") {
      throw ("Отсутствует подпись для проверки");
    }

    let oSignedData = cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");//cadescomMethods.oSignedData()//
    let oStoreAddressBook = cadesplugin.CreateObjectAsync("CAdESCOM.store");
    oStoreAddressBook.Open(cadesplugin.CAPICOM_CURRENT_USER_STORE, "AddressBook",  cadesplugin.CAPICOM_STORE_OPEN_READ_WRITE);
    oSignedData.AdditionalStore(oStoreAddressBook);

    let signType = cadesplugin.CADESCOM_CADES_A;

    try {
      signType = oSignedData.GetMsgType(sSignedMessage);
    }
    catch (err) { }

    let verifyResult = "Результат проверки неизвестен";
    let verifyResultSuccess = '<font color="green">Подпись проверена успешно</font>';
    let certThumbprints = [];

    dataInBase64 = Base64.encode(dataInBase64);
    oSignedData.ContentEncoding = cadesplugin.CADESCOM_BASE64_TO_BINARY;
    oSignedData.Content = dataInBase64;

    for (; ;) {
      try {
        oSignedData.VerifyCades(sSignedMessage, signType | cadesplugin.CADES_USE_OCSP_AUTHORIZED_POLICY, true);
      }
      catch (ex) {
        verifyResult = cadesplugin.getLastError(ex);
         // Перебираем все типы подписей, пока атрибуты в подписи не подойдут под тип
        if (verifyResult.indexOf("0x8009100F") >= 0 ||
            verifyResult.indexOf("0x8009200E") >= 0 ||
            verifyResult.indexOf("0x80070490") >= 0 ||
            // CADES-A поддерживается в версиях 2.0.15260+
            (signType == cadesplugin.CADESCOM_CADES_A && verifyResult.indexOf("0x80070057") >= 0)) {
          signType = getNextSignType(signType);
        } else {
          break;
        }
        if (!signType) {
          break;
        }
        continue;
      }
      verifyResult = verifyResultSuccess;
      break;
    }
    if (verifyResult != verifyResultSuccess)
      verifyResult = '<font color="red">' + verifyResult + '</font>';
    let sSignType = getSignTypeString(signType);
    let result = "";
    result += "Тип подписи: <b>" + sSignType + "</b><br/>"
    result += "Результат проверки: <b>" + verifyResult + "</b><br/><br/>"

    try {
      let oSigners = oSignedData.Signers;
      let nSigners = oSigners.Count;
      result += "Подписанты: <b>" + nSigners + "</b><br/>"

      for (let i = 1; i <= nSigners; i++) {
        let oSigner = oSigners.Item(i);
        let oCert = oSigner.Certificate;
        let certObj = new CertificateObj(oCert);
        let oSignStatus = oSigner.SignatureStatus;
        let isValidSignStatus = oSignStatus.IsValid;
        let isValidSign = "Ошибка при проверке подписи";
        if (isValidSignStatus) {
          isValidSign = "Подпись проверена успешно";
        }
        let isValidCertStatus = oCert.IsValid();
        isValidCertStatus = isValidCertStatus.Result;
        let isValidCert = "Ошибка при проверке статуса сертификата";
        if (isValidCertStatus) {
          isValidCert = "Сертификат действителен";
        }

        let subject = "-";
        let issuer = "-";
        let validFrom = "-";
        let validTo = "-";
        let thumbprint = "-";
        let signingTime = "-";
        try {
          subject = escapeHtml(certObj.GetCertName());
          issuer = escapeHtml(certObj.GetIssuer());
          validFrom = escapeHtml(certObj.GetCertFromDate()) + " UTC";
          validTo = escapeHtml(certObj.GetCertTillDate()) + " UTC";
          thumbprint = oCert.Thumbprint;
          certThumbprints.push(thumbprint);
          signingTime = oSigner.SigningTime;
        }
        catch (ex) { }
        result += i + ". Владелец: <b>" + subject + "</b><br/>";
        result += "&emsp;Издатель: <b>" + issuer + "</b><br/>";
        result += "&emsp;Выдан: <b>" + validFrom + "</b><br/>";
        result += "&emsp;Действителен до: <b>" + validTo + "</b><br/>";
        result += "&emsp;Отпечаток: <b>" + thumbprint + "</b><br/>";
        result += "&emsp;Статус сертификата: <b>" + isValidCert + "</b><br/>";
        result += "&emsp;Дата подписи: <b>" + signingTime + "</b><br/>";
        result += "&emsp;Статус подписи: <b>" + isValidSign + "</b><br/><br/>";
      }

    }
    catch (ex) { }

    return result;
  }
  catch (err) {
    alert(cadesplugin.getLastError(err))
  }
}*/

export async function ensureCadesPluginReady() {
  if (!window.cadesplugin?.CreateObjectAsync) {
    throw new Error("Плагин КриптоПро не установлен или не поддерживается в этом браузере");
  }
  try {
    await window.cadesplugin;
  } catch (e) {
    throw new Error(typeof e === "string" ? e : (e?.message || "Плагин КриптоПро недоступен"));
  }
  return window.cadesplugin;
}

export async function VerifySignature_Async(dataInBase64, sSignedMessage) {
    let isOk = false
    try {
      const cadesplugin = await ensureCadesPluginReady();
      if (sSignedMessage === "") {
        throw new Error("Отсутствует подпись для проверки");
      }

      //let Adjust = new CertificateAdjuster();
      let oSignedData = await cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

      let oStoreAddressBook = await cadesplugin.CreateObjectAsync("CAdESCOM.store");
      await oStoreAddressBook.Open(cadesplugin.CAPICOM_CURRENT_USER_STORE, "AddressBook", cadesplugin.CAPICOM_STORE_OPEN_READ_WRITE);
      await oSignedData.AdditionalStore(oStoreAddressBook);

      let signType = cadesplugin.CADESCOM_CADES_A;

      try {
        signType = await oSignedData.GetMsgType(sSignedMessage);
      }
      catch (err) { }


      let verifyResult = "Результат проверки неизвестен";
      let verifyResultSuccess = '<font color="green">Подпись проверена успешно</font>';
      let certThumbprints = [];

          //dataInBase64 = Base64.encode(dataInBase64);
        await oSignedData.propset_ContentEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);
        await oSignedData.propset_Content(dataInBase64);

      for (; ;) {
        try {
          await oSignedData.VerifyCades(sSignedMessage, signType | cadesplugin.CADES_USE_OCSP_AUTHORIZED_POLICY, true);
        }
        catch (ex) {
          verifyResult = cadesplugin.getLastError(ex);
            // Перебираем все типы подписей, пока атрибуты в подписи не подойдут под тип
          if (verifyResult.indexOf("0x8009100F") >= 0 ||
              verifyResult.indexOf("0x8009200E") >= 0 ||
              verifyResult.indexOf("0x80070490") >= 0 ||
              // CADES-A поддерживается в версиях 2.0.15260+
              (signType === cadesplugin.CADESCOM_CADES_A && verifyResult.indexOf("0x80070057") >= 0))
          {
            signType = getNextSignType(signType);
          } else {
            break;
          }
          if (!signType) {
            break;
          }
          continue;
        }
        verifyResult = verifyResultSuccess;
        break;
      }
      if (verifyResult !== verifyResultSuccess)
        verifyResult = '<font color="red">' +  verifyResult + '</font>';
      let sSignType = await getSignTypeString(signType, cadesplugin);
      let result = "";
      result += "Тип подписи: <b>" + sSignType + "</b><br/>"
      result += "Результат проверки: <b>" + verifyResult + "</b><br/><br/>"

      try {
        let oSigners = await oSignedData.Signers;
        let nSigners = await oSigners.Count;
        result += "Подписанты: <b>" + nSigners + "</b><br/>"

        let Adjust = new CertificateAdjuster();
        for (let i = 1; i <= nSigners; i++) {
          let oSigner = await oSigners.Item(i);
          let oCert = await oSigner.Certificate;
          let oSignStatus = await oSigner.SignatureStatus;
          let isValidSignStatus = await oSignStatus.IsValid;
          let isValidSign = "Ошибка при проверке подписи";
          if (isValidSignStatus) {
            isValidSign = "Подпись проверена успешно";
            isOk = true;
          }
          let isValidCertStatus = await oCert.IsValid();
          isValidCertStatus = await isValidCertStatus.Result;
          let isValidCert = "Ошибка при проверке статуса сертификата";
          if (isValidCertStatus) {
            isValidCert = "Сертификат действителен";
          }

          let subject = "-";
          let issuer = "-";
          let validFrom = "-";
          let validTo = "-";
          let thumbprint = "-";
          let signingTime = "-";
          try {
            subject = escapeHtml(Adjust.GetCertName(await oCert.SubjectName));
            issuer = escapeHtml(Adjust.GetIssuer(await oCert.IssuerName));
            validFrom = escapeHtml(Adjust.GetCertDate(await oCert.ValidFromDate)) + " UTC";
            validTo = escapeHtml(Adjust.GetCertDate(await oCert.ValidToDate)) + " UTC";
            thumbprint = await oCert.Thumbprint;
            certThumbprints.push(thumbprint);
            signingTime = escapeHtml(Adjust.GetCertDate(await oSigner.SigningTime)) + " UTC";
          }
          catch (ex) { }
          result += i + ". Владелец: <b>" + subject + "</b><br/>";
          result += "&emsp;Издатель: <b>" + issuer + "</b><br/>";
          result += "&emsp;Выдан: <b>" + validFrom + "</b><br/>";
          result += "&emsp;Действителен до: <b>" + validTo + "</b><br/>";
          result += "&emsp;Отпечаток: <b>" + thumbprint + "</b><br/>";
          result += "&emsp;Статус сертификата: <b>" + isValidCert + "</b><br/>";
          result += "&emsp;Дата подписи: <b>" + signingTime + "</b><br/>";
          result += "&emsp;Статус подписи: <b>" + isValidSign + "</b><br/><br/>";
        }

      }
      catch (ex) { }
      return {result, isOk};

    }
    catch(err)
    {
      const message = window.cadesplugin?.getLastError
        ? window.cadesplugin.getLastError(err)
        : (err?.message || String(err));
      return {
        result: '<font color="red">' + message + '</font>',
        isOk: false
      };
    }
}

//region dop func

  //region for async verify

    //region CertificateAdjuster
    function CertificateAdjuster()
    {
    }

    CertificateAdjuster.prototype.checkQuotes = function(str)
    {
      var result = 0, i = 0;
      for(i;i<str.length;i++)if(str[i]==='"')
        result++;
      return !(result%2);
    }

    CertificateAdjuster.prototype.extract = function(from, what)
    {
      var certName = "";

      var begin = from.indexOf(what);

      if(begin>=0)
      {
        var end = from.indexOf(', ', begin);
        while(end > 0) {
          if (this.checkQuotes(from.substr(begin, end-begin)))
            break;
          end = from.indexOf(', ', end + 1);
        }
        certName = (end < 0) ? from.substr(begin) : from.substr(begin, end - begin);
      }

      return certName;
    }

    CertificateAdjuster.prototype.Print2Digit = function(digit)
    {
      return (digit<10) ? "0"+digit : digit;
    }

    CertificateAdjuster.prototype.GetCertDate = function(paramDate)
    {
      var certDate = new Date(paramDate);
      return this.Print2Digit(certDate.getUTCDate())+"."+this.Print2Digit(certDate.getUTCMonth()+1)+"."+certDate.getFullYear() + " " +
          this.Print2Digit(certDate.getUTCHours()) + ":" + this.Print2Digit(certDate.getUTCMinutes()) + ":" + this.Print2Digit(certDate.getUTCSeconds());
    }

    CertificateAdjuster.prototype.GetCertName = function(certSubjectName)
    {
      return this.extract(certSubjectName, 'CN=');
    }

    CertificateAdjuster.prototype.GetIssuer = function(certIssuerName)
    {
      return this.extract(certIssuerName, 'CN=');
    }

    CertificateAdjuster.prototype.GetCertInfoString = function(certSubjectName, certFromDate)
    {
      return this.extract(certSubjectName,'CN=') + "; Выдан: " + this.GetCertDate(certFromDate);
    }

    //endregion

  //endregion

let Base64 = {


  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",


  encode: function(input) {
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

    }

    return output;
  },


  decode: function(input) {
    let output = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;

    input = input.replace(/[^A-Za-z0-9+/=]/g, "");

    while (i < input.length) {

      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }

    }

    output = Base64._utf8_decode(output);

    return output;

  },

  _utf8_encode: function(string) {
    string = string.replace(/\r\n/g, "\n");
    let utftext = "";

    for (let n = 0; n < string.length; n++) {

      let c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      }
      else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      }
      else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  },

  _utf8_decode: function(utftext) {
    let string = "";
    let i = 0;
    let c, c2, c3;
    c = c2 = c3 = 0;

    while (i < utftext.length) {

      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      }
      else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      }
      else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }

    }

    return string;
  }

}

function escapeHtml(unsafe)
{
  return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
}

function getNextSignType(signType, ccpa) {
  // Порядок обхода: CADES-A -> CADES-X Long Type 1 -> CADES-T -> CADES-BES -> PKCS7
  if (signType === ccpa.CADESCOM_CADES_A)
    return ccpa.CADESCOM_CADES_X_LONG_TYPE_1;
  if (signType === ccpa.CADESCOM_CADES_X_LONG_TYPE_1)
    return ccpa.CADESCOM_CADES_T;
  if (signType === ccpa.CADESCOM_CADES_T)
    return ccpa.CADESCOM_CADES_BES;
  if (signType === ccpa.CADESCOM_CADES_BES)
    return ccpa.CADESCOM_PKCS7_TYPE;
  return 0;
}

async function getSignTypeString(signType, cadesplugin) {
  if (signType === cadesplugin.CADESCOM_CADES_A)
    return "CAdES-A";
  if (signType === cadesplugin.CADESCOM_CADES_X_LONG_TYPE_1)
    return "CAdES-X Long Type 1";
  if (signType === cadesplugin.CADESCOM_CADES_T)
    return "CAdES-T";
  if (signType === cadesplugin.CADESCOM_CADES_BES)
    return "CAdES-BES";
  if (signType === cadesplugin.CADESCOM_PKCS7_TYPE)
    return "PKCS7";
  return "Неизвестно";
}

function CertificateObj(certObj){
  this.cert = certObj;
  this.certFromDate = new Date(this.cert.ValidFromDate);
  this.certTillDate = new Date(this.cert.ValidToDate);
}

CertificateObj.prototype.check = function(digit)
{
  return (digit<10) ? "0"+digit : digit;
}

CertificateObj.prototype.checkQuotes = function(str)
{
  let result = 0, i = 0;
  for(i;i<str.length;i++)if(str[i]==='"')
    result++;
  return !(result%2);
}

CertificateObj.prototype.extract = function(from, what)
{
  let certName = "";

  let begin = from.indexOf(what);

  if(begin>=0)
  {
    let end = from.indexOf(', ', begin);
    while(end > 0) {
      if (this.checkQuotes(from.substr(begin, end-begin)))
        break;
      end = from.indexOf(', ', end + 1);
    }
    certName = (end < 0) ? from.substr(begin) : from.substr(begin, end - begin);
  }

  return certName;
}

CertificateObj.prototype.DateTimePutTogether = function(certDate)
{
  return this.check(certDate.getUTCDate())+"."+this.check(certDate.getUTCMonth()+1)+"."+certDate.getFullYear() + " " +
      this.check(certDate.getUTCHours()) + ":" + this.check(certDate.getUTCMinutes()) + ":" + this.check(certDate.getUTCSeconds());
}

CertificateObj.prototype.GetCertString = function()
{
  return this.extract(this.cert.SubjectName,'CN=') + "; Выдан: " + this.GetCertFromDate();
}

CertificateObj.prototype.GetCertFromDate = function()
{
  return this.DateTimePutTogether(this.certFromDate);
}

CertificateObj.prototype.GetCertTillDate = function()
{
  return this.DateTimePutTogether(this.certTillDate);
}

CertificateObj.prototype.GetPubKeyAlgorithm = function()
{
  return this.cert.PublicKey().Algorithm.FriendlyName;
}

CertificateObj.prototype.GetCertName = function()
{
  return this.extract(this.cert.SubjectName, 'CN=');
}

CertificateObj.prototype.GetIssuer = function()
{
  return this.extract(this.cert.IssuerName, 'CN=');
}

CertificateObj.prototype.GetPrivateKeyProviderName = function()
{
  return this.cert.PrivateKey.ProviderName;
}

CertificateObj.prototype.GetPrivateKeyLink = function () {
  return this.cert.PrivateKey.UniqueContainerName;
}
//endregion
